import React from 'react';
import { useTheme } from '@/hooks/useTheme';
import { cn } from '@/utils/cn';

export interface LoadingSpinnerProps {
  message?: string;
  className?: string;
  spinnerSize?: 'sm' | 'md' | 'lg';
  fullScreen?: boolean;
}

export const LoadingSpinner: React.FC<LoadingSpinnerProps> = ({
  message = 'Loading...',
  className,
  spinnerSize = 'md',
  fullScreen = true,
}) => {
  const { isDark } = useTheme();

  const sizeClass = {
    sm: 'h-8 w-8',
    md: 'h-12 w-12',
    lg: 'h-16 w-16',
  }[spinnerSize];

  const containerBaseClasses = fullScreen
    ? 'min-h-screen flex items-center justify-center px-4'
    : 'w-full flex items-center justify-center';

  return (
    <div
      className={cn(
        containerBaseClasses,
        fullScreen ? (isDark ? 'bg-secondary-900' : 'bg-secondary-50') : '',
        className,
      )}
    >
      <div className="text-center">
        <div
          className={cn(
            'animate-spin rounded-full border-b-2 border-primary-600 mx-auto mb-4',
            sizeClass,
          )}
        ></div>
        <p className={cn(isDark ? 'text-secondary-400' : 'text-secondary-600')}>
          {message}
        </p>
      </div>
    </div>
  );
};
